var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.hasStats)?_c('div',[_c('h3',[_vm._v("Accuracy throughout Journey")]),(_vm.series[0].data.length > 1)?_c('apexchart',{attrs:{"height":"300","type":"line","options":_vm.options,"series":_vm.series}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }